import { callApi } from '@/api/apibase'

export const fetchCustomerRegistrationRelations = function () {
  return callApi('GET',`/api/external/greencourse/GetCustomerRegistrationRelations`)
}